import { t } from '@lingui/macro';
import React from 'react';

import { useContentfulUrl } from '../../../components/contentful-url-button/use-contentful-url';
import { ErrorPageModal } from '../../../page/page-modal/error-page/error-page-modal';

export function UnderMaintenanceError () {
    const headingText = t`Under Maintenance`;
    const mathleticsHome = useContentfulUrl('Mathletics Home');
    const bodyText = t({
        id: 'Error - Page - Under - Maintenance',
        values: { mathleticsHome }
    });

    return (
        <ErrorPageModal
            data-testid={'under-maintenance-route'}
            headingText={headingText}
            bodyText1={bodyText}
        />
    );
}
